export const InviteProcessStatusEnum  = {
  'Não enviado': 1,
  'Enviado': 2,
  'Erro ao enviar': 3
}
